import type { PlatformInfo } from "../api";
import { PlatformIcon } from "./PlatformIcon";

/**
 * A small 9:16 content thumbnail. Uses the post's own image when one is present
 * (image media with a URL); otherwise falls back to a tasteful platform-tinted
 * placeholder carrying the platform's brand mark. Video-frame extraction is
 * deliberately out of scope for v1, so a video post shows the placeholder.
 */
export function Thumbnail({
  mediaUrl,
  mediaKind,
  platform,
  large = false,
}: {
  mediaUrl?: string;
  mediaKind?: "video" | "image" | "text";
  platform?: PlatformInfo;
  large?: boolean;
}) {
  const cls = `cc-thumb${large ? " cc-thumb--lg" : ""}`;

  if (mediaKind === "image" && mediaUrl) {
    return (
      <span className={cls}>
        <img src={mediaUrl} alt="" loading="lazy" />
      </span>
    );
  }

  // Platform-tinted placeholder: a soft wash of the platform accent + its mark.
  const tint = platform?.accent ?? "#3a3d42";
  return (
    <span
      className={`${cls} cc-thumb--placeholder`}
      style={{
        background: `linear-gradient(150deg, ${tint}, color-mix(in srgb, ${tint} 55%, #111))`,
      }}
    >
      {platform ? (
        <PlatformIcon platform={platform} size={large ? 20 : 15} />
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <rect x="3" y="3" width="18" height="18" rx="3" />
          <path d="M8 13l3-3 4 4 1-1 2 2" />
        </svg>
      )}
    </span>
  );
}
